import * as React from "react";
import { useTranslations } from "../../i18n/useTranslations";
import { prefixedWithLang } from "../../utils";

import { useSearch } from "../useSearch";

export function PopularItemsList() {
  const { lang } = useTranslations();
  const { popularItems } = useSearch();

  return (
    <ul className="elm-m-0 elm-p-0 elm-grid elm-grid-flow-row elm-grid-cols-2 lg:elm-grid-cols-5 md:elm-grid-cols-5 elm-gap-2 elm-list-none">
      {popularItems.map((item, index) => (
        <li key={index}>
          <a
            href={prefixedWithLang(lang, item.href)}
            className="elm-transition elm-bg-dd-blue-50 elm-text-center lg:hover:elm-bg-dd-blue-100 lg:hover:elm-text-dd-gray-500 elm-rounded-xl elm-py-4 focus:elm-outline-none elm-text-base elm-cursor-pointer elm-pointer-events-auto elm-no-underline elm-block"
          >
            <span className="elm-text-dd-gray-900 elm-font-sans elm-text-base elm-font-semibold">
              {item.label}
            </span>
          </a>
        </li>
      ))}
    </ul>
  );
}
